import type { ReactNode } from "react";

import { cn } from "@/lib/utils/cn";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./card";

export type DataPanelProps = {
  title: string;
  description?: string;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
  titleClassName?: string;
  flush?: boolean;
};

export function DataPanel({ title, description, actions, children, className, flush, titleClassName }: DataPanelProps) {
  return (
    <Card padding="none" className={cn("overflow-hidden", className)}>
      <CardHeader className="flex-row items-center justify-between gap-ds-4">
        <div className="min-w-0 space-y-ds-1">
          <CardTitle className={titleClassName}>{title}</CardTitle>
          {description ? <CardDescription>{description}</CardDescription> : null}
        </div>
        {actions ? <div className="flex shrink-0 flex-wrap gap-ds-2">{actions}</div> : null}
      </CardHeader>
      <CardContent className={cn(flush ? "p-0" : "p-ds-5")}>{children}</CardContent>
    </Card>
  );
}
